module.exports = __webpack_public_path__ + "static/img/1.08da7e02.jpg";